import components from './components'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import computed from './computed'

export default {
  components,
  data,
  methods,
  mounted,
  computed
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/index.js